import constants from 'app/constants'
import { ERROR_CODE } from 'app/util/errorCodes'
import { API_ERROR_RESPONSE_MESSAGE, API_RESPONSE } from './constants'
import getSignature from './getSignature'

/**
 * Mint with a signature
 *
 * @param {object} formData - the form data
 * @param {object} signer - the signer info
 * @returns {object?} the result or null if failed
 */
const editWithSignature = async (formData, signer) => {
  const signature = await getSignature(formData.wallet, signer)

  if (!signature) {
    // Fail
    return null
  }

  const response = await fetch(
    `${constants.API_V2_URL}/frontend/blockchain/edit_avatar`,
    {
      method: 'POST',
      body: JSON.stringify({
        ...formData,
        network: constants.NETWORK
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Signature': signature
      }
    }
  )

  return response
}

/**
 * Mint avatar with wallet provider - note that this is only currently
 * to be used for non-paper based wallets (given paper wallets are
 * required to use the `mintAvatarWithPaper` approach)
 *
 * @param {string} walletAddress - the user wallet address
 * @param {object} submissionData - the compiled checkout data
 * @param {Function} getSigner - the signer method
 * @returns {Promise} resolves on completion
 */
const mintEditAvatarWithFreeMint = async (
  walletAddress,
  submissionData,
  getSigner
) => {
  const { accessoryIdsToAttach, accessoryIdsToDetach, id } = submissionData
  let res

  try {
    const signer = await getSigner()

    res = await editWithSignature(
      {
        avatar_id: id,
        accessoryIdsToAttach,
        accessoryIdsToDetach,
        wallet: walletAddress
      },
      signer
    )

    if (res.status === 504) {
      // Detect timeout
      return {
        success: true,
        didTimeout: true,
        message: ERROR_CODE.TIMEOUT
      }
    }

    if (res.ok) {
      res = await res.json()
    }
  } catch (error) {
    console.error(error)
  }

  if (!res) {
    // Total fail
    return {
      success: false,
      message: ERROR_CODE.UNKNOWN
    }
  }

  if (res?.message === API_RESPONSE.EDIT_SUCCESS) {
    // Mint succeeded
    return {
      success: true
    }
  }

  // Graceful fail
  return {
    success: false,
    message: API_ERROR_RESPONSE_MESSAGE[res?.message] || ERROR_CODE.UNKNOWN
  }
}

// Export
export default mintEditAvatarWithFreeMint
